import { InjectionToken } from '@angular/core';

export const COMPANY_BASE_URL = new InjectionToken<string>('company-base-url');
